<template>
  <div class="apply-friend">
    <div class="title">
      <span>好友申请记录</span>
    </div>
    <div class="item_list">
      <div class="item" v-for="user in applyList" :key="user.id">
        <div class="name">
          {{ user.nickName }}申请添加您为好友
          <span v-if="user.status == 1">(已同意)</span>
          <span v-if="user.status == 2">(已拒绝)</span>
        </div>
        <div class="operation" v-if="user.status == 0">
          <el-button type="primary" @click="handleAccept(user)">同意</el-button>
          <el-button type="danger" @click="handleReject(user)">拒绝</el-button>
        </div>
      </div>
      <el-empty
        v-if="applyList.length === 0"
        description="暂无好友申请记录"
      ></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: "applyFriend",
  data() {
    return {
      applyList: [
        // {
        //   id: 1,
        //   userId: 1,
        //   nickName: "张三",
        //   status: 0,
        // },
        // {
        //   id: 2,
        //   userId: 2,
        //   nickName: "李四",
        //   status: 0,
        // },
        // {
        //   id: 3,
        //   userId: 3,
        //   nickName: "王五",
        //   status: 0,
        // },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$http({
        url: "/friend/req/list",
        method: "get",
      }).then((data) => {
        this.applyList = data;
      });
    },
    handleAccept(user) {
      this.$http({
        url: "/friend/handle",
        method: "post",
        data: {
          relationId: user.userId,
          status: 1,
        },
      }).then(() => {
        this.$message.success("好友请求已同意");
        this.init();
      });
    },
    handleReject(user) {
      this.$http({
        url: "/friend/handle",
        method: "post",
        data: {
          relationId: user.userId,
          status: 2,
        },
      }).then(() => {
        this.$message.success("好友请求已拒绝");
        this.init();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-friend {
  height: 100%;
  background-color: #f5f7fa;
  padding: 15px;
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
  }
  .item_list {
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow-y: scroll;
    max-height: calc(100% - 40px);
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    .item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e4e7ed;
      padding-bottom: 10px;
      padding-top: 10px;
      .name {
        width: 300px;
      }
    }
  }
}
</style>
